import { sharedLocalStorage } from '@/shared/helpers';
import { tokenIsExpired } from '@/shared/modules/auth/helpers';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { useAuthStore } from '../auth.state';
import { decodeToken } from '../decodeToken';
/**
 * Token validation and storing to auth state is necessary before all other requests of router's rootLoader, because of
 * wrong notification (about no access to specified endpoint) will be shown if token is already expired. No reason to
 * send root requests with expired token.
 */
const validateToken = createAsyncThunk('auth/validateToken', async (params, { rejectWithValue, fulfillWithValue }) => {
    try {
        const token = sharedLocalStorage.getItem('token');
        // If somehow we've got broken value from local storage.
        if (token === null || token === 'null' || token === 'undefined' || token === '') {
            if (token !== null)
                sharedLocalStorage.removeItem('token');
            return rejectWithValue('No token in localStorage.');
        }
        const expiration = decodeToken(token).expiration;
        if (tokenIsExpired(expiration)) {
            sharedLocalStorage.removeItem('token');
            return rejectWithValue('Token is expired.');
        }
        useAuthStore.getState().useToken(token);
        return fulfillWithValue(true);
    }
    catch (error) {
        console.error(`validateToken request error:`, error);
        if (error instanceof Error) {
            return rejectWithValue(`validateToken request failed.`);
        }
        return rejectWithValue('Server unexpected error');
    }
});
export { validateToken };
